<script setup lang="ts">
import { CollapsibleRoot } from "reka-ui"

const { to, activePrefix } = defineProps<{
  to: string
  activePrefix?: string
}>()

const { isOpen: sidebarOpen } = useSidebarNavigation()
const route = useRoute()

const isActive = computed(() => {
  return route.path.startsWith(activePrefix ?? to)
})

const open = computed(() => {
  return sidebarOpen.value && isActive.value
})
</script>

<template>
  <div v-if="sidebarOpen">
    <CollapsibleRoot :open class="group">
      <div class="relative">
        <SidebarNavigationItem :to>
          <slot name="icon" />
          <slot />
          <SvgoPikaChevronBigDown
            class="ml-auto size-4 shrink-0 text-zinc-500 transition-transform duration-200 group-data-[state=open]:rotate-180"
          />
          <span
            v-if="isActive"
            class="absolute inset-y-2 -left-1.5 w-0.5 rounded-full bg-zinc-950 @[12rem]/navigation:-left-3"
          />
        </SidebarNavigationItem>
      </div>

      <slot name="content" />
    </CollapsibleRoot>
  </div>
  <SidebarNavigationItem v-else :to>
    <slot name="icon" />
    <slot />
  </SidebarNavigationItem>
</template>
